export default __webpack_public_path__ + "static/media/cronoselumntexplorer.5a2dbab3.svg";